<template>
  <div style="min-height: calc(100% - 160px);">
  <div id="pricePublic">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>渠道政策</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ChannelPolicy/pricePublic' }">售价公示</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page_container">
      <el-row>
        <el-col :span="10" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">
          <div style="margin: 20px;">
            <el-tag type="warning"><img src="../../assets/img/other/trumpet_icon.png" style="margin-left: 13px;margin-right: 5px;">
            <span>小提示：常用分类方式有：品牌、品类系列等。请选择一种最适合的分类去管理。</span></el-tag>
          </div>
        </el-col>

        <el-col :span="14" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">
          <div style="margin: 20px;text-align: right;">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" size="small" placeholder="请输入分类名称查询" prefix-icon="el-icon-search" v-model="productClassifyName" style="margin-right: 12px;width: 320px;"></el-input>
            <el-button @click="oneStep" size="small">查询</el-button>
            <el-button @click="BrandSet" size="small">变更历史</el-button>
            <el-button @click="batchOutage" size="small" type="primary">批量导入</el-button>
            <el-button @click="exportExcel" size="small">全表导入模板下载</el-button>
          </div>
        </el-col>

        <el-col :span="24" v-show="type.logintype != 'HCM' && type.logintype != 'HCMSUB' && type.logintype != 'KEFU'">
          <div style="margin: 20px;text-align: right;">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" size="small" placeholder="请输入分类名称查询" prefix-icon="el-icon-search" v-model="productClassifyName" style="margin-right: 12px;width: 320px;"></el-input>
            <el-button @click="oneStep" size="small">查询</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="newClassification">
      <!-- 新增分类 -->
      <el-row style="margin: 0 -8px;">
        <el-col :span="6"  v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'">
          <div class="titlediv2" @click="add(1)" v-if="type.editStatus">
            <i class="el-icon-circle-plus-outline" style="margin-top: 45px;color: #d9d9d9;font-size: 30px;" ></i>
            <div style="font-weight: 600;">新增分类</div>
          </div>
        </el-col>
        <!-- 新增分类 -->
        <el-col :span="6" v-show="addShow">
          <div class="titlediv3">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="newProductClassifyName" placeholder="请输入品类名称" style="margin-left: 20px;margin-top: 20px;margin-bottom: 10px;width: 90%;" size="small"></el-input>
            <br>
            <div style="text-align: right;margin-right: 20px;margin-top: 5px;margin-bottom: 15px;">
              <i class="el-icon-close" style="color: #2997ef;font-size: 20px;margin-right: 5px;" @click="add(2)"></i>
              <i class="el-icon-check" style="color: #2997ef;font-size: 20px;" @click="addClassification(1)"></i>
            </div>
          </div>
        </el-col>

        <el-col :span="6" v-for="(item,index) in tableData"  id="promptDelete2">
          <!-- 详情 -->
          <div class="titlediv2" v-if="dialogVisible[index] == true">
            <div style="height: 100px;" @click="BrandSet2(item.id,item.productClassifyName)">
              <div style="font-size: 16px;font-weight: 600;padding-top: 30px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" >
                {{item.productClassifyName}}
              </div>
            </div>
            <div style="display: inline-flex;width: 100%;" v-show="type.logintype == 'HCM' || type.logintype == 'HCMSUB' || type.logintype == 'KEFU'" >
              <div style="width: 100%;margin-top: 3px;" id="eleButton1" v-show="type.logintype == 'KEFU'">
                <el-button style="width: 100%;" plain icon="el-icon-document" @click="copy(item.id)">复制</el-button>
              </div>
              <div style="width: 100%;margin-top: 3px;" id="eleButton2" v-if="type.editStatus">
                <el-button style="width: 100%;" plain icon="el-icon-edit-outline" @click="theEditor(item.productClassifyName,item.leaderName,item.id,item.leaderId,index)">编辑</el-button>
              </div>
              <div style="width: 100%;margin-top: 3px;" id="eleButton2" v-show="type.logintype != 'DEALER' && type.logintype != 'HCM' && type.logintype != 'HCMSUB' && type.logintype != 'SHOP'">
                <el-button style="width: 100%;" plain icon="el-icon-delete" @click="promptDelete(item.id)">删除</el-button>
              </div>
            </div>
          </div>
          <!-- 编辑 -->
          <div class="titlediv3" v-if="dialogVisible[index] == false">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="newProductClassifyName2[index]" placeholder="请输入品类名称" style="margin-left: 20px;margin-top: 20px;margin-bottom: 10px;width: 90%;" size="small"></el-input>
            <br>
            <div style="float: right;margin-right: 20px;margin-top: 5px;margin-bottom: 15px;">
              <i class="el-icon-close" style="color: #2997ef;font-size: 20px;margin-right: 5px;" @click="editorCancel(index)"></i>
              <i class="el-icon-check" style="color: #2997ef;font-size: 20px;" @click="addClassification(2,index)"></i>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="deleteShow"
      width="20%" style="margin-top: 10%;" id="deleteShowStyle">
      <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
         <div>
             <div style="font-size: 16px;">你确认要删除该产品分类吗？</div>
             <div style="font-size: 14px;">删除后
             <span style="color: #e90e24;font-size: 14px;">录入的公示信息将会被删除</span>
          </div>
         </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteClassification" size="small">确 定</el-button>
        <el-button @click="deleteShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量导入"
      class="importModal"
      :visible.sync="BulkImportShow"
      :close-on-click-modal="false"
      width="640px"
      id="dialog">
      <div class="wrap" style="margin: 10px;">
        <el-upload
          ref="newupload"
          class="upload-demo"
          drag
          action="hcm/ProductClassify/readExcelFile"
          :auto-upload="false"
          multiple
          :before-upload="beforeUpload"
          accept=".xls,.xlsx"
          :on-success="confirmUpload"
          >
          <i class="el-icon-upload" style="color: #BDA571;"></i>
          <div class="el-upload__text" style="font-size: 16px;color: #333333;">将文件拖到此处，或<em>点击上传</em>
            <br>
            <span style="font-size: 14px;color: #d4d4d4;">
              支持扩展名：.xls .xlsx
            </span>
          </div>
        </el-upload>
        <div v-if="errData.length != 0">
          <el-alert
            title="错误信息，请更改后重新导入或单独新增。"
            type="warning"
            show-icon
            style="margin: 20px 0;">
          </el-alert>
          <el-table
           :data="errData"
           style="width: 100%">
           <el-table-column
             prop="serial"
             label="行号">
           </el-table-column>
           <el-table-column
             prop="err_info"
             label="错误说明">
           </el-table-column>
         </el-table>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button v-if="errData.length != 0" @click="exportErrorExcel()" size="small" :loading="bulLoading">下载错误数据</el-button>
        <el-button type="primary" @click="BulkImport()" size="small" :loading="bulLoading">确 定</el-button>
        <el-button @click="BulkImportShowf()" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        input: '',
        addShow: false,
        dialogVisible: [],
        deleteShow: false,
        pageNo: 1,
        pageSize: 10000,
        tableData: [],
        errData: [],
        productClassifyName: '',
        newProductClassifyName: '',
        newProductClassifyName2: [],
        leaderId: '',
        deleteId: '',
        leaderId2: '',
        type: '',
        BulkImportShow: false,
        bulLoading: false,
        downloadPath: '',
      }
    },
    mounted() {
      this.type = JSON.parse(window.localStorage.userData)
      console.log(this.type.logintype)
      this.oneStep();
    },
    methods: {
      batchOutage() {
        this.errData = []
        this.BulkImportShow = true
      },
      BulkImportShowf() {
        this.BulkImportShow = false
        this.$refs.newupload.clearFiles();
      },
      BulkImport() {
        this.bulLoading = true
        this.$refs.newupload.submit();
      },
      beforeUpload(file) {
        let Xls = file.name
        if(Xls.search("xls") != -1 || Xls.search("xlsx") != -1){
          return file
        }else {
          this.$message.error('上传文件只能是 xls/xlsx 格式!')
          return false
        }
      },
      confirmUpload(response) {
        this.bulLoading = false
        this.errData = []
        this.downloadPath = ''
        if (response.data && response.data.errList.length != 0) {
          this.errData = response.data.errList
          this.downloadPath = response.data.downloadPath
        } else {
          this.BulkImportShow = false
        }
      },
      exportErrorExcel() {
        this.bulLoading = true
        let params = {
          path: this.downloadPath
        }
        fetch({
					url: "hcm/ProductClassify/exportErrorExcel",
					method: "get",
          params: params,
					noFormat: true,
					responseType: "blob",
          timeout: 60 * 1000 * 5
  			})
  			.then((res)=>{
  				//下载
  				let url = window.URL.createObjectURL(new Blob([res]))
  				let link = document.createElement('a')
  				link.style.display = 'none'
  				link.href = url
  				link.setAttribute('download', '错误数据.xlsx')
  				document.body.appendChild(link)
  				link.click()
          this.bulLoading = false
  			})
      },
      exportExcel() {
        fetch({
					url: "hcm/ProductClassify/exportExcel",
					method: "get",
					noFormat: true,
					responseType: "blob",
          timeout: 60 * 1000 * 5
  			})
  			.then((res)=>{
  				//下载
  				let url = window.URL.createObjectURL(new Blob([res]))
  				let link = document.createElement('a')
  				link.style.display = 'none'
  				link.href = url
  				link.setAttribute('download', '全表导入模板.xlsx')
  				document.body.appendChild(link)
  				link.click()
          this.downloadLoading = false
  			})
      },
      editorCancel(index) {
        this.$set(this.dialogVisible,index,true);
      },
      BrandSet() {
        this.$router.push({
          path: '/changeHistory'
        })
      },
      BrandSet2(e,f,h) {
        this.$router.push({
          path: '/productInformation',query: {e,f}
        })
      },
      theEditor(e,f,h,z,index) {
        this.$set(this.dialogVisible,index,false);
        this.newProductClassifyName2[index] = e
        this.deleteId = h
        this.leaderId = z
      },
      copy(id) {
        let params = {
          id: id
        }
        fetch({
          url: "hcm/ProductClassify/copy",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.oneStep();
          } else {
           this.$message({
             message: res.message,
             type: 'warning'
           });
          }
         }).catch(err => {
           this.$message.error('接口异常');
         })
      },
      handleNodeClick(data) {
        if (data.type == 'user') {
          this.leaderId = data.value
        }
      },
      handleNodeClick2(data) {
        if (data.type == 'user') {
          this.leaderId2 = data.value
        }
     },
     addClassification(e,index) {
       let params={}
       if (e == 1) {
         if (this.newProductClassifyName == '') {
           this.$message.error('请输入品类名称');
           return;
         }
         params.leaderId = this.leaderId;
         params.productClassifyName = this.newProductClassifyName;
       } else {
         if (this.newProductClassifyName2[index] == '') {
           this.$message.error('请输入品类名称');
           return;
         }
         params.leaderId = this.leaderId2;
         params.productClassifyName = this.newProductClassifyName2[index];
         params.id = this.deleteId
       }
       fetch({
         url: "hcm/ProductClassify/save",
         method: "post",
         params: params,
         noFormat: true,
         responseType: "text"
       }).then(result => {
         let res = JSON.parse(result);
         let {data}=res
         if(res.status == '10000'){
           // this.dialogVisible[index] = false;
           this.$set(this.dialogVisible,index,false);
           this.oneStep()
           this.addShow = false;
         } else {
          this.$message({
            message: res.message,
            type: 'warning'
          });
         }
        })
        .catch(err => {
          this.$message.error('接口异常');
        })
      },
      deleteClassification() {
        let params={
          id: this.deleteId
        }
        fetch({
          url: "hcm/ProductClassify/deleteById",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.deleteShow = false;
            this.oneStep()
          }
         })
         .catch(err => {
           this.$message.error('接口异常');
         })
       },
      oneStep() {
        let params={
          pageNum: this.pageNo,
          pageSize: this.pageSize,
          isClassify: true
        }
        if (this.productClassifyName) {
          params.productClassifyName = this.productClassifyName
        }
        fetch({
          url: "hcm/ProductClassify/seletProductClassify",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.dialogVisible = []
            this.tableData = data.data.list;
            for (let a in this.tableData) {
              this.dialogVisible[a] = true
            }
            console.log(this.dialogVisible)
          }
        })
        .catch(err => {
          this.$message.error('接口异常');
        })
      },
      add(e) {
        this.newProductClassifyName = '';
        // this.leaderName = '';
        if (e == 1) {
          this.addShow = true
        } else {
          this.addShow = false
        }
      },
      promptDelete(e) {
        this.deleteShow = true
        this.deleteId = e
      },

    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .page_container {
    margin: 20px 20px 0px 20px;
    background-color: white;
  }
  .newTitlediv {
    background-color: white;
    text-align: center;
    cursor: pointer;
    margin: 5px;
    height: 140px;
  }
  .titlediv2 {
    background-color: white;
    text-align: center;
    cursor: pointer;
    margin: 8px;
    height: 140px;
  }
  .titlediv2:hover {
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    color: #2997ef;
  }
  .titlediv3 {
    background-color: white;
    cursor: pointer;
    margin-right: 15px;
    height: 140px;
    margin: 5px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }

</style>
<style lang="scss">
#pricePublic {
  .newClassification {
    min-height: calc(100% - 130px);
    margin: 10px 20px 20px 20px;
    min-width: 900px;
    position: relative;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .titlediv2 .el-button+.el-button {
    margin-left:0px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
  #eleButton1 {
    .el-button {
      border-radius: 0 0 0 4px !important;
      border: none !important;
      border-top: 1px solid #DCDFE6 !important;
    }
    .el-button.is-plain:focus, .el-button.is-plain:hover {
      background: white !important;
      border-top: 1px solid #DCDFE6 !important;
      color: #409EFF;
    }
  }
  #eleButton2 {
    .el-button {
      border-radius: 0 0 0 4px !important;
      border: none !important;
      border-top: 1px solid #DCDFE6 !important;
      border-left: 1px solid #DCDFE6 !important;
    }
    .el-button.is-plain:focus, .el-button.is-plain:hover {
      background: white !important;
      border-top: 1px solid #DCDFE6 !important;
      color: #409EFF;
    }
  }
  #promptDelete2 {
    .el-button--primary {
      color: #666;
      background-color: white;
      border-color: #DCDFE6;
      // border-right: none;
    }
    .el-button--primary:hover{
      color: #fff;
      background-color: #409EFF;
      border-color: #409EFF;
    }
  }
  #deleteShowStyle {
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }

}
</style>
